interface PrivacyModalProps {
  isOpen: boolean
  onClose: () => void
}

function PrivacyModal({ isOpen, onClose }: PrivacyModalProps) {
  if (!isOpen) return null

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4 py-8 overflow-y-auto"
      onClick={onClose}
    >
      <div 
        className="bg-white rounded-none max-w-4xl w-full max-h-[90vh] overflow-y-auto relative shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sticky top-0 bg-white border-b-2 border-black px-6 sm:px-10 py-6 flex justify-between items-center">
          <h2 className="text-2xl sm:text-3xl font-bold text-black uppercase">Политика конфиденциальности</h2>
          <button
            onClick={onClose}
            className="text-4xl font-bold text-black hover:text-[#F45B3C] transition-colors leading-none"
            aria-label="Закрыть"
          >
            ×
          </button>
        </div>

        <div className="px-6 sm:px-10 py-8 text-black space-y-6">
          <p className="text-center text-lg font-semibold text-[#1E2B3C]">(обработка персональных данных)</p>

          <section>
            <h3 className="text-xl font-bold mb-3 text-black">1. Общие положения</h3>
            <p className="mb-2 text-gray-800 leading-relaxed">
              <strong>1.1.</strong> Настоящая Политика конфиденциальности определяет порядок обработки персональных данных Пользователя в соответствии с Федеральным законом РФ № 152-ФЗ «О персональных данных».
            </p>
            <p className="mb-2 text-gray-800 leading-relaxed">
              <strong>1.2.</strong> Использование сайта и/или оформление заказа означает согласие Пользователя с условиями Политики.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-bold mb-3 text-black">2. Сбор и обработка персональных данных</h3>
            <p className="mb-2 text-gray-800 leading-relaxed">
              <strong>2.1.</strong> Персональные данные — это любые сведения, позволяющие идентифицировать Пользователя, включая:
            </p>
            <ul className="list-disc ml-6 mb-2 text-gray-800 leading-relaxed space-y-1">
              <li>ФИО / Имя</li>
              <li>Адрес электронной почты</li>
              <li>Телефон</li>
              <li>Другие контактные данные, если они запрашиваются при оформлении доступа или подписки.</li>
            </ul>
            <p className="mb-2 text-gray-800 leading-relaxed">
              <strong>2.2.</strong> Мы можем также автоматически собирать технические данные (IP-адрес, cookie, данные о браузере).
            </p>
          </section>

          <section>
            <h3 className="text-xl font-bold mb-3 text-black">3. Цели обработки данных</h3>
            <p className="mb-2 text-gray-800 leading-relaxed">
              <strong>3.1.</strong> Обработка персональных данных осуществляется:
            </p>
            <ul className="list-disc ml-6 mb-2 text-gray-800 leading-relaxed space-y-1">
              <li>для выполнения договора с Пользователем,</li>
              <li>для предоставления доступа к Продукту,</li>
              <li>для связи с пользователем (уведомления, обратная связь),</li>
              <li>для маркетинговых целей только при отдельном согласии.</li>
            </ul>
          </section>

          <section>
            <h3 className="text-xl font-bold mb-3 text-black">4. Передача данных третьим лицам</h3>
            <p className="mb-2 text-gray-800 leading-relaxed">
              <strong>4.1.</strong> Персональные данные не передаются третьим лицам, за исключением:
            </p>
            <ul className="list-disc ml-6 mb-2 text-gray-800 leading-relaxed space-y-1">
              <li>сервисов оплаты (в объёме, необходимом для проведения платежа),</li>
              <li>технических провайдеров, обеспечивающих работу сайта,</li>
              <li>иных случаев, предусмотренных законодательством РФ.</li>
            </ul>
          </section>

          <section>
            <h3 className="text-xl font-bold mb-3 text-black">5. Защита данных</h3>
            <p className="mb-2 text-gray-800 leading-relaxed">
              <strong>5.1.</strong> Оператор принимает организационные и технические меры для защиты данных от несанкционированного доступа, утраты или разрушения.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-bold mb-3 text-black">6. Права Пользователя</h3>
            <p className="mb-2 text-gray-800 leading-relaxed">
              <strong>6.1.</strong> Пользователь вправе:
            </p>
            <ul className="list-disc ml-6 mb-2 text-gray-800 leading-relaxed space-y-1">
              <li>получать доступ к своим данным,</li>
              <li>требовать удаления или уточнения данных,</li>
              <li>отзывать согласие на обработку в любой момент.</li>
            </ul>
          </section>

          <section>
            <h3 className="text-xl font-bold mb-3 text-black">7. Контактные данные</h3>
            <p className="mb-2 text-gray-800 leading-relaxed">
              <strong>7.1.</strong> Все вопросы по обработке персональных данных направляйте на контактный email администратора сайта.
            </p>
          </section>

          <p className="text-center text-sm text-gray-600 mt-8">
            Обновлено: 21.01.2026 г.
          </p>
        </div>

        <div className="sticky bottom-0 bg-white border-t-2 border-black px-6 sm:px-10 py-6">
          <button
            onClick={onClose}
            className="w-full bg-black text-white py-4 text-lg font-bold uppercase hover:bg-[#1E2B3C] transition-colors"
          >
            Закрыть
          </button>
        </div>
      </div>
    </div>
  )
}

export default PrivacyModal
